import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

const DARK_MODE_DATA = 'dark-mode-data';

@Injectable({
    providedIn: 'root'
})
export class DarkModeService {

  constructor(private storage: Storage) {  }

      async getDarkMode(){
        return this.storage.get(DARK_MODE_DATA).then((val) => {
            return (val) ? val : '';
        });
      }

      async setDarkMode(m){

        if (m !== '') {
            const mode = (m === 'true') ;

            if (mode) {
                document.body.classList.toggle('dark', true);
            }else{
                document.body.classList.remove('dark');
                document.body.classList.toggle('light', true);
            }
        }else{
            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
            document.body.classList.toggle('dark', prefersDark.matches);
        }
        await this.storage.set(DARK_MODE_DATA, m);
      }
}
